import React, { FunctionComponent } from 'react';
import { SearchParamsItem } from '../SearchParamsItem';
import { TourPeriod } from '../TourPeriod';
import { StayTime } from '../StayTime';
import { SearchParamsTourists } from '../SearchParamsTourists';
import { StyledSearchParamsItem, Wrapper } from './SearchParams.style';
import { Package } from '@lt/api/dist/methods/packages/types';

// TODO
type Props = {
  datesInfo: Package['dates_info'];
  adultsCount: number;
  kidsCount: number;
  kidsAges: number[];
  parentWidth?: number;
};

export const SearchParams: FunctionComponent<Props> = ({
  datesInfo,
  adultsCount,
  kidsCount,
  kidsAges,
  parentWidth,
}) => {
  return (
    <Wrapper parentWidth={parentWidth}>
      <StyledSearchParamsItem parentWidth={parentWidth}>
        <TourPeriod startDate={datesInfo.start_date} endDate={datesInfo.end_date} />
      </StyledSearchParamsItem>
      <SearchParamsItem parentWidth={parentWidth}>
        <StayTime nightsCount={datesInfo.nights_count} originalNights={datesInfo.original_nights} />
      </SearchParamsItem>
      <SearchParamsItem parentWidth={parentWidth}>
        <SearchParamsTourists
          parentWidth={parentWidth}
          kidsCount={kidsCount}
          adultsCount={adultsCount}
          kidsAges={kidsAges}
        />
      </SearchParamsItem>
    </Wrapper>
  );
};
